var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',[_c('div',{staticClass:"editorBox",attrs:{"id":"editor","height":_vm.height}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }